import { ref, computed, onBeforeMount } from 'vue-demi';
import { UP_DOWN_TYPE_CLS } from '../common/enum';
import NNQ from '@futuweb/tool-nn/dist/nnq';
const { useVariable } = require('@fegobull/webapi').use;

export default (props) => {
    const { IS_NN } = useVariable();

    const upDownType = ref(props.upDownType);

    const upDownTypeCls = computed(() => {
        return UP_DOWN_TYPE_CLS[upDownType.value];
    });

    const setUpDownType = () => {
        // 执行
        const run = () => {
            window.NNWebViewJSBridge.callHandler('getUpDownType', {}, (res) => {
                try {
                    const { result, data } = JSON.parse(res) || {};
                    // data: 涨跌色，0-红涨绿跌, 1-绿涨红跌, 2-粉涨绿跌, 3-绿涨粉跌
                    if (result === 0) {
                        upDownType.value = data;
                    }
                } catch (e) {
                    console.error(e);
                }
            });
        };
        if (window?.NNWebViewJSBridge?.callHandler) {
            run();
        } else {
            NNQ.initBridge({}, () => {
                run();
            });
        }
    };

    IS_NN && onBeforeMount(setUpDownType);

    return {
        upDownTypeCls
    };
};
